<h2 mat-dialog-title class="my-content-title">
	{{ 'MARK_CLOSED' | translate }}
</h2>

<mat-dialog-content class="my-content">
	<div id="close-warning-message">
		{{ 'CLOSE_TASK_MESSAGE_WARNING' | translate }}
	</div>

	<div style="display: flex; gap: 16px; margin-top: 24px">
		<button mat-raised-button style="flex: 1; color: white" (click)="reallyClose()" cdkFocusInitial>
			{{ 'YES' | translate }}
		</button>
		<button mat-raised-button style="flex: 1" (click)="this.dialogRef.close()">
			{{ 'NO' | translate }}
		</button>
	</div>
</mat-dialog-content>
